import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ValidationInput, CreateChancel, MaskInput, SelectTypeAutocomplete } from 'components';
import {
    EmailValidator,
    ErrorText,
    FindErrorItem,
    FindLoad,
    FindSuccessItem,
    getPhoneErrorText,
    hooksForErrors,
    isNotEmpty,
    useModal,
} from 'utils';
import { clientActions, formActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { formBuilderStatusEnums } from 'pages/forms/constants';

const ACTION_TYPE = 'CREATE_CLIENT_INTAKE_FORM';
const GET_FORMS = 'GET_FORMS';

export const ClientIntakeForm = ({ afterSuccess }) => {
    const forms = useSelector((state) => state.forms.forms);
    const [error, setError] = useState('');
    const [inputs, setInputs] = useState({});
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const phoneErrorMsg = getPhoneErrorText(inputs.phoneNumber);
    const emailErrorMsg = !EmailValidator.test(inputs.email) ? ErrorText.emailValid : '';
    const phoneErrorText = hooksForErrors.getPhoneError(error, backError, phoneErrorMsg);
    const emailErrorText = hooksForErrors.getEmailError(error, backError, emailErrorMsg);
    const { close } = useModal();

    useEffect(() => {
        dispatch(formActions.getForms({ model: 'INTAKE_FORM', status: formBuilderStatusEnums.PUBLISHED }));
    }, []);

    useEffect(() => {
        if (success?.type === ACTION_TYPE) {
            afterSuccess?.();
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
        if (backError && phoneErrorText) {
            setError(phoneErrorText);
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        }
        if (backError?.error === 'User already exists in another organization.') {
            setError(phoneErrorText);
        }
    }, [success, backError]);

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        error === e.target.name && setError('');
    };

    const handleCreate = () => {
        const emailIsValid = isNotEmpty(inputs.email) && EmailValidator.test(inputs.email);
        const isValid = isNotEmpty(inputs.firstName) && isNotEmpty(inputs.lastName) && isNotEmpty(inputs.formId) && emailIsValid;

        if (isValid) {
            const data = {
                firstName: inputs.firstName,
                middleName: inputs?.middleName ? inputs.middleName : null,
                lastName: inputs.lastName,
                email: inputs.email,
                phoneNumber: inputs?.phoneNumber ? parseInt(inputs?.phoneNumber.replace(/[^0-9]/g, '')) + '' : null,
                formId: inputs?.formId,
            };
            dispatch(clientActions.createIntakeForm(data));
        } else {
            const errMessage = !isNotEmpty(inputs.firstName)
                ? 'firstName'
                : // !isNotEmpty(inputs.middleName) ? 'middleName' :
                  !isNotEmpty(inputs.lastName)
                  ? 'lastName'
                  : !isNotEmpty(inputs.email)
                    ? 'email'
                    : // !isNotEmpty(inputs.phoneNumber) ? 'phoneNumber' :
                      !emailIsValid
                      ? emailErrorMsg
                      : !isNotEmpty(inputs.formId)
                        ? 'formId'
                        : '';
            setError(errMessage);
        }
    };

    return (
        <div style={{ width: 463 }}>
            <p style={{ textAlign: 'center' }} className="modal-header-title">
                {' '}
                Send Intake Form{' '}
            </p>
            <div className="modal-body-wrapper">
                <div>
                    <ValidationInput
                        variant={'outlined'}
                        onChange={handleChange}
                        value={inputs.firstName}
                        type={'text'}
                        label={'First Name*'}
                        name="firstName"
                        typeError={error === 'firstName' ? `First name ${ErrorText.isRequired}` : ''}
                        Length={25}
                    />
                    <ValidationInput
                        variant={'outlined'}
                        onChange={handleChange}
                        value={inputs.middleName}
                        type={'text'}
                        label={'Middle Name'}
                        name="middleName"
                        typeError={error === 'middleName' ? ErrorText.field : ''}
                        Length={25}
                    />
                    <ValidationInput
                        variant={'outlined'}
                        onChange={handleChange}
                        value={inputs.lastName}
                        type={'text'}
                        label={'Last Name*'}
                        name="lastName"
                        typeError={error === 'lastName' ? `Last name ${ErrorText.isRequired}` : ''}
                        Length={25}
                    />
                    <ValidationInput
                        validator={EmailValidator}
                        variant={'outlined'}
                        name={'email'}
                        type={'email'}
                        label={'Email Address*'}
                        typeError={emailErrorText}
                        value={inputs?.email}
                        onChange={handleChange}
                    />
                    <MaskInput
                        name="phoneNumber"
                        label="Phone Number"
                        value={inputs.phoneNumber}
                        handleChange={handleChange}
                        error={phoneErrorText}
                    />
                    <SelectTypeAutocomplete
                        loadType={GET_FORMS}
                        title={'Form*'}
                        name={'formId'}
                        handleSelect={handleChange}
                        defaultValue={inputs?.formId}
                        list={forms?.data}
                        error={error}
                        typeError={error === 'formId' ? ErrorText.selectField : ''}
                        renderValue={(i) => i?.title}
                    />
                </div>

                {/*<div className="send-form-link-wrapper">*/}
                {/*    <div className="send-form-link-box">*/}
                {/*        <p>Select how to send the form link</p>*/}
                {/*    </div>*/}
                {/*    <RadioGroup*/}
                {/*        style={{*/}
                {/*            display: 'flex',*/}
                {/*            alignItems: 'center',*/}
                {/*            flexDirection: 'row',*/}
                {/*            gap: 20,*/}
                {/*        }}*/}
                {/*        name="formLink"*/}
                {/*        value={inputs?.formLink}*/}
                {/*        onChange={handleChange}*/}
                {/*    >*/}
                {/*        {[*/}
                {/*            { title: 'Send via Email', value: 'EMAIL' },*/}
                {/*            { title: 'Send via SMS', value: 'SMS' },*/}
                {/*            { title: 'Both', value: 'BOTH' },*/}
                {/*        ]?.map((item, index) => (*/}
                {/*            <FormControlLabel*/}
                {/*                key={index}*/}
                {/*                value={item.value}*/}
                {/*                control={<Radio*/}
                {/*                    style={{*/}
                {/*                        color: inputs?.formLink === item?.value ? '#0C66E4' : '#D0D5DD',*/}
                {/*                    }}*/}
                {/*                    classes={{ root: classes.radio, checked: classes.checked }}*/}
                {/*                />}*/}
                {/*                label={item.title}*/}
                {/*            />*/}
                {/*        ))}*/}
                {/*    </RadioGroup>*/}
                {/*</div>*/}
            </div>
            <CreateChancel
                loader={!!loader.length}
                create={'Send Form'}
                chancel={'Cancel'}
                onCreate={handleCreate}
                onClose={close}
                buttonWidth="224px"
            />
        </div>
    );
};
